export const theme = {
  textStyles: {
    small: {
      fontSize: 14,
    },
    body: {
      fontSize: 16,
      fontWeight: 500,
    },
    h1: {
      fontSize: 48,
      fontWeight: 700,
    },
    h2: {
      fontSize: 24,
      fontWeight: 700,
    },
    h3: {
      fontSize: 18,
      fontWeight: 700,
    },
    h4: {
      fontSize: 15,
      fontWeight: 400,
    }
  },
};
// 14, 16, 18, 24, 48
